import { Service } from 'typedi';
import { ShowNotification } from '../ShowNotification';
import { axios } from '../axios';

@Service()
export class PushRequest {
  @ShowNotification()
  answerMeeting(meetingId: string, consumerId: string, confirm: boolean) {
    const path = confirm ? 'accept' : 'cancel';

    return axios
      .get(`user/answer/${path}?consumerId=${consumerId}&meetingId=${meetingId}`);
  }

  @ShowNotification()
  offerTime(meetingId: string, userId: string, offeredTime: Date) {
    return axios  
      .post('/user/answer/offer/time', { 
        meetingId, 
        userId, 
        offeredTime: [
          offeredTime.getHours(),
          offeredTime.getMinutes(),
          0,
          0,
        ]
      });
  }
}
